import { useContext } from 'react';

import { PlayerContext } from '.';

export const usePlayerContext = () => {
  return useContext(PlayerContext);
}
